// Components
import { Box, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { ISubscriptionProps } from "./constants";
import { V1SubscriptionManagement } from "./V1SubscriptionManagement";
import { V2SubscriptionManagement } from "./V2SubscriptionManagement";
import { useSmartrrTheme } from "../../../hooks/useSmartrrTheme";

export const Subscriptions = (props: ISubscriptionProps): JSX.Element => {
  const theme = useSmartrrTheme();
  const showSectionTitles = theme.modernThemeSettings?.showHide.showSectionTitles;

  const SubscriptionManagement = () => {
    if (theme.modernThemeSettings?.sections.subscriptions.altView1 && props.upcomingDelivery) {
      return <V2SubscriptionManagement {...props} />;
    }

    return <V1SubscriptionManagement {...props} />;
  };

  return (
    <Box sx={{ marginTop: "40px" }} className={prefixClassName("subscriptions")}>
      <span className="anchor" id="subscriptions" />
      {showSectionTitles ? <Typography variant="h2">{typedLocalize("subscriptions.title")}</Typography> : null}
      <SubscriptionManagement />
    </Box>
  );
};
